import { render, staticRenderFns } from "./orderFreight.vue?vue&type=template&id=1043e8cc&scoped=true"
import script from "./orderFreight.vue?vue&type=script&lang=js"
export * from "./orderFreight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1043e8cc",
  null
  
)

export default component.exports